module.exports = __webpack_public_path__ + "img/home_fr2.8e16d1eb.png";